@if (loading()) {
  <div class="inline-flex items-center justify-center w-full h-full">
    <vti-icons [icon]="'spinner'" [size]="20"></vti-icons>
  </div>
} @else {
  <div class="h-52 w-full sm:w-126" #containerBarRef>
    <ngx-charts-advanced-pie-chart
      [view]="[containerBarRef.offsetWidth, containerBarRef.offsetHeight]"
      [scheme]="colorScheme()"
      [results]="results()"
      [gradient]="gradient()"
      i18n-label
      label="Hectares"
      [animations]="false"
      [valueFormatting]="formatValue"
      [percentageFormatting]="formatPercent"
    >
    </ngx-charts-advanced-pie-chart>
  </div>
}
